<app-strip-wrapper *ngIf="promotionStrip"></app-strip-wrapper>
<app-header [promotionStrip]="promotionStrip" *ngIf="!isErrorPage()" [class.header-contact]="!isContactPage()"></app-header>
<div [ngClass]="promotionStrip?'router-wrapper_strip':'router-wrapper'">
    <router-outlet></router-outlet>
</div>
